import React from 'react';
import { NavLink } from 'react-router-dom';
import Locale, { LanguageCode } from 'localization/Localization';
import { UserProvider } from 'components/contexts/UserContext';
import { getCurrentLanguage } from 'components/contexts/LocalizationContext';

interface PublicProps {
	onLanguageChangedCallback: () => void;
}

interface PublicState {
	language: LanguageCode;
	languagePickerVisible: boolean;
	availableLanguages: LanguageCode[];
}

export class PublicHeader extends React.Component<PublicProps, PublicState> {

	constructor(props: PublicProps) {
		super(props);

		this.state = {
			language: getCurrentLanguage(),
			languagePickerVisible: false,
			availableLanguages: Locale.getAvailableLanguageCodes()
		};

		this.onToggleLanguagePicker = this.onToggleLanguagePicker.bind(this);
		this.onSelectLanguage = this.onSelectLanguage.bind(this);
	}

	public componentDidMount() {

	}

	private onToggleLanguagePicker() {
		this.setState({
			languagePickerVisible: !this.state.languagePickerVisible
		});
	}

	private onSelectLanguage(lang: LanguageCode) {
		UserProvider.setLanguage(lang);
		//	Locale.setFallbackLanguage(lang);

		this.setState({
			language: lang,
			languagePickerVisible: false
		});

		this.props.onLanguageChangedCallback();
	}

	public render() {
		return <div className='header'>

			{this.state.languagePickerVisible &&
				<div className='overlay' onClick={this.onToggleLanguagePicker} />
			}

			<div className='center-container'>
				<NavLink className='brand-logo' to={'/'}><span>{Locale.get('home_title')}</span></NavLink>

				<div className='flex-grow-1'></div>

				<div className='lang-container'>
					<div className='lang-indicator' onClick={this.onToggleLanguagePicker} >
						<img src={'/assets/images/lang/' + this.state.language + '.png'} alt={this.state.language} />
						<p>{this.state.language.toUpperCase()}</p>
					</div>

					{this.state.languagePickerVisible &&
						<div className='lang-picker'>
							{this.state.availableLanguages.map(lang => {
								return <div className='lang-item' key={lang} onClick={() => this.onSelectLanguage(lang)} >
									<img src={'/assets/images/lang/' + lang + '.png'} alt={lang} />
									<p key={lang}>{lang.toUpperCase()}</p>
								</div>
							})}
						</div>
					}
				</div>

			</div>
		</div>;
	}
}
